import React from "react";
import logoImage from '../../assets/icon_trucktronix.png';
import "./header.css";

const Header = ({title}) => {
    return (
        <div className="b2b-div-header">
            <img src={logoImage} alt='trucktronix' className="logo-image" />
            <h4>B2B {title}</h4>
        </div>
    )
};

export default Header;